export default "__VITE_ASSET__DU5nov6w__"